import {
    TerminationDemographics,
    TerminationTime
} from '../components/termination';

export const TerminationRoutes = [
    { path: '/Terminate/Demographics', component: TerminationDemographics },
    { path: '/Terminate/Time', component: TerminationTime },
]